export default {
    company_avatar: 'Slika kompanije',
    user_avatar: 'Slika korisnika',
    top_companies: 'Top kompanije',
    reservation: 'Rezervacija',
    company_cover: 'Cover slika kompanije',
    offer_details: 'Detalji usluge',
    map_marker: 'Marker mape',
    offer_cover: 'Cover usluge',
    user_rating: 'User rating',
    clock: 'Clock',
    rating_trophy: 'Rating trhophy',
    user_image: 'User image',
    offer_image: 'Offer image',
}
